import axios from "axios";
import api from "./api";

export async function getConfig() {
  try {
    const res = await api.get(`app/settings`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function documentUpload(payload) {
  try {
    const res = await api.post(`docs`, payload);
    return res;
  } catch (err) {
    throw err;
  }
}

export const uploadFileToSignedUrl = async (file, signedUrl) => {
  try {
    const res = await axios.put(signedUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    });
    return res;
  } catch (err) {
    throw err;
  }
};

export async function downloadFileFromSignedUrl(fileKey) {
  try {
    const res = await api.get(`docs?fileKey=${fileKey}`);
    return res;
  } catch (err) {
    throw err;
  }
}
